import { render, staticRenderFns } from "./EducationalCourses.vue?vue&type=template&id=1b74d0ac&"
import script from "./EducationalCourses.vue?vue&type=script&lang=js&"
export * from "./EducationalCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports